import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowUpRight} from "react-icons/fi";
import forward from "../../Assets/next-arrow.png";
import Navbar from "../../Components/Navbar/Navbar";
import ContactCTA from "../../Components/ContactCTA/ContactCTA";
import Footer from "../../Components/Footer/Footer";
import "./ServicesPage.css";

import {
  FiZap,
 
  FiUsers,
  FiAward
} from "react-icons/fi";

import {
  
  FiArrowRight,
  FiVideo,
  FiCamera,
  FiFilm,
  FiPenTool,
  FiMonitor,
  FiTrendingUp,
} from "react-icons/fi";

const services = [
  {
    number: "01",
    icon: FiVideo,
    title: "End-to-End Video Production",
    tagline: "Stories That Inspire. Content That Performs.",
    description:
      "Complete production solutions from creative concept and scripting to filming, post-production and final delivery.",
    items: [
      "Commercial Video Production",
      "Corporate Films",
      "Brand Storytelling",
      "Product Videos",
    ],
    more: "9 MORE CAPABILITIES",
  },
  {
    number: "02",
    icon: FiCamera,
    title: "Content Production & Management",
    tagline: "Consistency Builds Strong Brands.",
    description:
      "Strategic content planning, production and management designed to keep brands visible, relevant and engaging.",
    items: [
      "Content Strategy",
      "Monthly Content Planning",
      "Creative Direction",
      "Reels & Short Videos",
    ],
    more: "6 MORE CAPABILITIES",
  },
  {
    number: "03",
    icon: FiFilm,
    title: "Films & Commercials",
    tagline: "Powerful Stories. Lasting Impressions.",
    description:
      "Cinematic films and premium commercial productions that create emotional connections and strengthen brand identity.",
    items: [
      "TV & Digital Commercials",
      "Brand Films",
      "Product Launch Videos",
      "Luxury Campaigns",
    ],
    more: "4 MORE CAPABILITIES",
  },
  {
    number: "04",
    icon: FiPenTool,
    title: "Branding",
    tagline: "Build A Brand People Trust.",
    description:
      "Distinctive brand identities and visual systems created to communicate professionalism, consistency and credibility.",
    items: [
      "Brand Strategy",
      "Logo Design",
      "Visual Identity",
      "Brand Guidelines",
    ],
    more: "5 MORE CAPABILITIES",
  },
  {
    number: "05",
    icon: FiMonitor,
    title: "Development",
    tagline: "Digital Experiences Designed To Convert.",
    description:
      "Modern websites and digital experiences that communicate value, establish trust and turn visitors into customers.",
    items: [
      "Business Websites",
      "Landing Pages",
      "UI / UX Design",
      "Custom Development",
    ],
    more: "5 MORE CAPABILITIES",
  },
  {
    number: "06",
    icon: FiTrendingUp,
    title: "Marketing",
    tagline: "Creativity Turned Into Growth.",
    description:
      "Marketing strategy and creative execution designed to increase visibility, generate leads and support sustainable growth.",
    items: [
      "Marketing Strategy",
      "Brand Positioning",
      "Campaign Planning",
      "Growth Consulting",
    ],
    more: "5 MORE CAPABILITIES",
  },
];



const benefits = [
  {
    icon: FiZap,
    number: "01",
    title: "Creative Thinking",
    description:
      "Every project starts with an original idea shaped around your audience, goals and brand identity."
  },
  {
    icon: FiVideo,
    number: "02",
    title: "End-to-End Production",
    description:
      "From the first conversation to final delivery, our team manages every stage of the creative process."
  },
  {
    icon: FiUsers,
    number: "03",
    title: "Collaborative Approach",
    description:
      "We work closely with you throughout the project so every decision stays aligned with your vision."
  },
  {
    icon: FiAward,
    number: "04",
    title: "Attention to Detail",
    description:
      "Every frame, visual and interaction is carefully refined to deliver work that feels considered."
  }
];

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 60
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

function ServicesPage() {
  return (
    <>
      <Navbar />

      <main className="sp-page">

        <section className="sp-hero">

          <div className="sp-hero-glow"></div>

          <div className="sp-container">

            <motion.h1
              className="sp-hero-title"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Our Services
            </motion.h1>

            <motion.p
              className="sp-hero-description"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Creative thinking, powerful storytelling and thoughtful
              production crafted to transform ideas into experiences
              audiences remember
            </motion.p>

            <motion.div
              className="sp-hero-actions"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <Link to="/contact" className="sp-primary-btn">
                Start Your Project
                <img
                  src={forward}
                  alt="arrow"
                  className="cta-arrow"
                />
              </Link>
            </motion.div>

          </div>

        </section>

        <section className="sp-services-section">

          <div className="sp-container">

            <motion.div
              className="sp-section-heading"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >



              <h2>
                Everything Your Brand
                Needs To Stand Out
              </h2>

              <p>
                From strategy and creative direction to production and
                delivery, we bring every part of the creative process
                together under one roof.
              </p>

            </motion.div>

          <div className="services-grid">
                    {services.map((service) => {
                      const Icon = service.icon;
          
                      return (
                        <article
                          className="service-card"
                          key={service.number}
                        >
                          <div className="service-glow">
                            <span className="service-glow-left" />
                            <span className="service-glow-right" />
                            <span className="service-glow-bottom" />
                            <span className="service-glow-core" />
                            <span className="service-glow-rim" />
                            <span className="service-glow-corner" />
                          </div>
          
                          <div className="service-card-content">
                            <div className="service-card-top">
                              <span className="service-number">
                                {service.number}
                              </span>
          
                              <div className="service-icon">
                                <Icon />
                              </div>
                            </div>
          
                            <div className="service-main">
                              <h3 className="service-title">
                                {service.title}
                              </h3>
          
                              <p className="service-tagline">
                                {service.tagline}
                              </p>
          
                              <p className="service-description">
                                {service.description}
                              </p>
          
                              <div className="service-list">
                                {service.items.map((item) => (
                                  <div
                                    className="service-list-item"
                                    key={item}
                                  >
                                    <FiArrowUpRight />
          
                                    <span>{item}</span>
                                  </div>
                                ))}
                              </div>
          
                              <span className="service-more">
                                + {service.more}
                              </span>
                            </div>
          
                            <footer className="service-footer">
                              <span>EXPLORE SERVICE</span>
          
                              <FiArrowRight />
                            </footer>
                          </div>
                        </article>
                      );
                    })}
                  </div>

          </div>

        </section>

        <section className="sp-benefits-section">

          <div className="sp-container">

            <motion.div
              className="sp-section-heading"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >

             

              <h2>
                Benefits Of Working With Us
               
              </h2>

              <p>
                Creative solutions designed to help businesses grow through branding, design, development,
                 marketing, and content creation
              </p>

            </motion.div>

            <div className="sp-benefits-grid">

             {benefits.map((benefit, index) => {
  const Icon = benefit.icon;

  return (
    <motion.article
      className="sp-benefit-card"
      key={benefit.number}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: index * 0.1,
        duration: 0.7
      }}
      viewport={{ once: true }}
    >
      <div className="sp-benefit-top">
        <span className="sp-benefit-number">
          {benefit.number}
        </span>

        <div className="sp-benefit-icon">
          <Icon />
        </div>
      </div>

      <h3>{benefit.title}</h3>

      <p>{benefit.description}</p>
    </motion.article>
  );
})}

            </div>

          </div>

        </section>

      </main>

      <ContactCTA />

      <Footer />
    </>
  );
}

export default ServicesPage;